export enum InviteFormFields {
  emails = 'emails',
}

export type InviteFormValues = {
  [InviteFormFields.emails]: string[];
};
